import React, { useEffect } from 'react';
import './index.scss';
import { WarningFilled } from '@ant-design/icons';
import BussinessApi from '@/fetch/bussiness';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { RemoteCommandType } from '@/utils/constant';
import { useIsTakeOverBySelf } from '@/utils/hooks';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import { CockpitRealtimeErrorCode } from '@/utils/enum';

const AEBAlertBar = () => {
  const requestApi = new BussinessApi();
  const router = useLocation();
  const queryList: any = router.search.split('?')[1];
  const query = qs.parse(queryList);
  const vehicleName: string = query.vehicleName;
  const userName = useSelector(
    (state: RootState) => state.login.userInfo?.userName
  );
  const cockpitNumber = useSelector(
    (state: RootState) => state.newCommon.cockpitNumber
  );
  const controlBtn = useSelector((state: RootState) => state.controlBtn);
  const errorCode = useSelector(
    (state: RootState) => state.cockpitRealtime.errorCode
  );

  const takeOverBySelf = useIsTakeOverBySelf();

  const isVisible =
    takeOverBySelf &&
    errorCode === CockpitRealtimeErrorCode.ERROR_VEHICLE_AEB_IS_TRUE;

  useEffect(() => {
    if (takeOverBySelf && controlBtn?.LC_BUTTON_MINUS && isVisible) {
      onClose();
    }
  }, [takeOverBySelf, controlBtn?.LC_BUTTON_MINUS, isVisible]);

  const onClose = () => {
    requestApi
      .buttonCommand({
        cockpitNumber: cockpitNumber,
        vehicleName: vehicleName,
        cockpitUserName: userName,
        remoteCommandType: RemoteCommandType.RELEASE_AEB_BRAKE,
      })
      .then((res) => {
        if (res.code === HttpStatusCode.Success) {
          message.success('释放AEB制动指令下发成功');
        } else {
          message.error(res.message);
        }
      });
  };
  if (!isVisible) return null;
  return (
    <div className="aeb-alert-bar">
      <div className="aeb-alert-bar__content">
        <div className="aeb-alert-bar__icon-container">
          <WarningFilled />
        </div>

        <div className="aeb-alert-bar__text-container">
          <span className="aeb-alert-bar__title">AEB 紧急制动已触发</span>
          <span className="aeb-alert-bar__subtitle">
            前方检测到危险，请确认安全后释放制动
          </span>
        </div>

        <button onClick={onClose} className="aeb-alert-bar__button">
          <i className="fa-solid fa-gamepad"></i>
          取消制动
        </button>
      </div>
    </div>
  );
};

export default React.memo(AEBAlertBar);
